export default __webpack_public_path__ + "static/media/32.0fd52a7c.gif";